// @flow
import md5 from 'md5';
import format from 'date-fns/format';

// Action Type
import { SET_CURRENT_PATH } from 'store/reducers/navigation/actionTypes';

// Constants
import {
  VEHICLE_ROUTE,
  SERVICES_ROUTE,
  APPOINTMENT_ROUTE,
  REVIEW_ROUTE,
  CONFIRMATION_ROUTE
} from 'constants/routes';

// Selectors
import { getConversantTrackingDetails } from 'store/reducers/dealerData/selectors';
import {
  getVin,
  makeSelectedSelector,
  getYear,
  getModel,
  getMileage,
  getTotalPrice,
  getServicePoint,
  getParamRecalls,
  getParamServices,
  getStartTime,
  getConfirmationKey
} from 'store/reducers/appointment/selectors';
import { getEmail } from 'store/reducers/appointment/contactInfo/selectors';
import { getPriceVisibility } from 'store/reducers/dealerSettings/selectors';

// types
import type { State, Action } from 'types/redux';

const getConversantTrackingData = (state, isPageVisit) => {
  const params = {};
  const vin = getVin(state);
  let make;
  let year;
  let model;
  const email = getEmail(state);
  let mileage;
  const serviceTypeArr = [];
  if (vin) {
    params.vehicleVin = vin;
  }
  if (isPageVisit) {
    make = makeSelectedSelector(state);
    year = getYear(state);
    model = getModel(state);
    mileage = getMileage(state);
    if (make) {
      params.vehicleMake = make;
    }
    if (year) {
      params.vehicleYear = year;
    }
    if (model) {
      params.vehicleModel = model;
    }
    if (mileage) {
      params.vehicleMileage = mileage;
    }
    if (email) {
      params.customerEmail = md5(email);
    }
    return params;
  }
  const servicePoint = getServicePoint(state);
  const recalls = getParamRecalls(state);
  const services = getParamServices(state);
  params.appointmentDate = format(getStartTime(state), 'MM-DD-YYYY');
  if (email) {
    params.customerEmail = md5(email);
  }
  // recommended package
  if (servicePoint) {
    serviceTypeArr.push(
      `${(servicePoint.mileage / 1000).toFixed(0)}K ${
        servicePoint.menuType.description
      }`
    );
  }
  // additional services
  if (services.length > 0) {
    for (let i = 0; i < services.length; i += 1) {
      serviceTypeArr.push(services[i].name);
    }
  }
  // recalls
  if (recalls.length > 0) {
    for (let i = 0; i < recalls.length; i += 1) {
      serviceTypeArr.push(recalls[i].name);
    }
  }
  if (serviceTypeArr.length > 0) {
    params.apptServicesType = serviceTypeArr.join('|');
  }
  if (getPriceVisibility(state)()) {
    params.apptServiceValue = getTotalPrice(state);
  }
  return params;
};

export const clickTrackerMiddleware = ({
  getState
}: {
  getState: () => State
}) => (next: (action: Action) => any) => (action: any) => {
  const { type, payload } = action;
  const conversantTrackingDetails = getConversantTrackingDetails(getState());
  if (type === SET_CURRENT_PATH && conversantTrackingDetails) {
    const {
      conversantPageTrackingConfig,
      conversantConversionTrackingConfig
    } = conversantTrackingDetails;
    const clientPromoId = {
      [VEHICLE_ROUTE]: 30,
      [SERVICES_ROUTE]: 31,
      [APPOINTMENT_ROUTE]: 32,
      [REVIEW_ROUTE]: 33,
      [CONFIRMATION_ROUTE]: 130
    };
    /* eslint-disable camelcase */
    const keyMapping = {
      dtm_com: 'conversantDtmCom',
      dtm_fid: 'conversantDtmFid',
      dtm_cid: 'conversantDtmCid',
      dtm_cmagic: 'conversantDtmCmagic',
      dtm_format: 'conversantDtmFormat'
    };
    /* eslint-enable camelcase */
    let dataLayerParams;
    if (payload === CONFIRMATION_ROUTE) {
      // Conversion tracking
      dataLayerParams = {
        event: 'conversantConversionEvent',
        conversantClientPromoId: clientPromoId[payload],
        appointmentId: getConfirmationKey(getState()),
        ...getConversantTrackingData(getState())
      };
      conversantConversionTrackingConfig.split('|').forEach(v => {
        const key = keyMapping[v.split('=')[0]];
        if (key) {
          dataLayerParams[key] = v.split('=')[1];
        }
      });
      window.dataLayer.push(dataLayerParams);
    } else if (
      payload === VEHICLE_ROUTE ||
      payload === SERVICES_ROUTE ||
      payload === APPOINTMENT_ROUTE ||
      payload === REVIEW_ROUTE
    ) {
      // Page visit tracking
      dataLayerParams = {
        event: 'clickTrackConversantPageView',
        conversantClientPromoId: clientPromoId[payload],
        ...getConversantTrackingData(getState(), true)
      };
      conversantPageTrackingConfig.split('|').forEach(v => {
        const key = keyMapping[v.split('=')[0]];
        if (key) {
          dataLayerParams[key] = v.split('=')[1];
        }
      });
      window.dataLayer.push(dataLayerParams);
    }
  }
  return next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/click-tracker.js